import { render, staticRenderFns } from "./ModalRespostaOcorrencia.vue?vue&type=template&id=0f79c32a&scoped=true"
import script from "./ModalRespostaOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalRespostaOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ModalRespostaOcorrencia.vue?vue&type=style&index=0&id=0f79c32a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79c32a",
  null
  
)

export default component.exports